import React__default from 'react';

const Spacer = ({ when = true, top, right, bottom, left, children }) => {
    const style = {};
    if (!when) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    if (top) {
        style.marginTop = `${top}px`;
    }
    if (right) {
        style.marginRight = `${right}px`;
    }
    if (bottom) {
        style.marginBottom = `${bottom}px`;
    }
    if (left) {
        style.marginLeft = `${left}px`;
    }
    return React__default.createElement("div", { style: style }, children);
};

export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
